import { getProducts } from '../api/api';
import { mapDtoToGrid } from '../util/util';
import { useEffect } from 'react';
import { useToast } from '../components/ToastContext';
import { useAppContext } from '../context/AppContext';

export const fetchAllProducts = (setRows, setOriginalRows, setIsLoggedIn, showToast) =>
  getProducts()
    .then((res) => mapDtoToGrid(res))
    .then((res) => {
      setRows(res);
      setOriginalRows(res);
    })
    .catch((e) => {
      if (e.status === 401) {
        setIsLoggedIn(false);
        showToast('Unauthorized. Please login again.', 'error');
      } else {
        showToast('An error occurred while loading products.', 'error');
      }
    });

export const useFetchProducts = () => {
  const { showToast } = useToast();
  const { setIsLoggedIn, setRows, setOriginalRows } = useAppContext();

  useEffect(() => {
    fetchAllProducts(setRows, setOriginalRows, setIsLoggedIn, showToast);
  }, []);

  return { showToast };
};
